<h2 class="dsd-t-4" tabindex="-1">{{ 'caad.valider.coordonnees.titre' | translate }}</h2>

<p>
  <span class="libelle">{{ 'caad.valider.coordonnees.libelle.adresse' | translate }}&nbsp;</span>
  <span class="valeur">{{ requeteModifierCoordonnees.adresseModification.numeroCiviqueNomRue }}</span>
</p>
<ng-container *ngIf="requeteModifierCoordonnees.adresseModification.numeroUnite">
  <p>
    <span class="libelle">{{ 'caad.valider.coordonnees.libelle.appartement' | translate }}&nbsp;</span>
    <span class="valeur">{{ requeteModifierCoordonnees.adresseModification.numeroUnite }}</span>
  </p>
</ng-container>
<p>
  <span class="libelle">{{ 'caad.valider.coordonnees.libelle.ville' | translate }}&nbsp;</span>
  <span class="valeur">{{ requeteModifierCoordonnees.adresseModification.nomMunicipalite }}</span>
</p>
<p>
  <span class="libelle">{{ 'caad.valider.coordonnees.libelle.province' | translate }}&nbsp;</span>
  <span class="valeur">{{
    'formulairePosteCanada.donneeReference.provinces.CA-' +
      requeteModifierCoordonnees.adresseModification.codeSubdivisionPays | translate
  }}</span>
</p>
<p class="dsd-mb-0">
  <span class="libelle">{{ 'caad.valider.coordonnees.libelle.codepostal' | translate }}&nbsp;</span>
  <span class="valeur dsd-mb-0">{{ requeteModifierCoordonnees.adresseModification.codePostal | codepostal }}</span>
</p>
